<template>
        <div class="head">
             <el-carousel :interval="1000 * 60 * 2" :height="bannerHeight + 'px'" @change="elCarousel" >
                <el-carousel-item v-for="(item,index) in hove.bannar" :key="index">
                    <el-image fit="contain" style="width:100%;height:100%"  :src="item.img"></el-image>
                    <!-- <h3 class="small">{{ item }}</h3> -->
                </el-carousel-item>
            </el-carousel>
            <div >
            <div class="first">
                <div :class="hove.state ? 'refer' :'referEnd'" v-for="(item,index) in hove.referrer" :key="item.img">
                    <el-image :class="'referrer' + index" :src="item.img"></el-image>
                    <div class="referrerData" :style="'left:' + item.left + 'top:' + item.top">
                        <div class="text_1">你想要这里有</div>
                        <div class="text_2">{{item.text}}</div>
                        <div class="text_3" :style="'color:'+ item.color">{{item.font}}</div>
                    </div>
                </div>
                <div class="referrer3">
                    <!-- {{message}} -->
                       <el-carousel height="10vw"  v-if="message">
                        <el-carousel-item v-for="(item,index) in message" :key="index">
                          <el-image style="height:100%" :src="item.snapshotUrl" fit="fill" @click="onClick(item)" ></el-image>
                        </el-carousel-item>
                      </el-carousel>
                     <div class="text_site">广告</div>
                </div>
            </div>
                        
            </div>
            <div class="dashed"></div>
            <div class="content">
                <div>
                    <div class="content_top">{{hove.content.top}}</div>
                    <div class="content_text">{{hove.content.text}}</div>
                    <div v-if="hove.state">
                         <div class="content_single"><el-image style="height:10px;width:10px;padding-right:10px"  :src="hove.iconImage"></el-image><span>数据化：科技赋能、降本增效管理工作数字化、信息化，智能数据分析。</span></div>
                        <table class="content_table">
                            <tr><td><el-image style="height:10px;width:10px;padding-right:10px"  :src="hove.iconImage"></el-image>协同共治：整体智治、高效协同</td><td><el-image style="height:10px;width:10px;padding-right:10px"  :src="hove.iconImage"></el-image>资金保障：银行担保、支付更有保障</td></tr>
                            <tr><td><el-image style="height:10px;width:10px;padding-right:10px"  :src="hove.iconImage"></el-image>高效监管：信用信息公示与管理</td><td><el-image style="height:10px;width:10px;padding-right:10px"  :src="hove.iconImage"></el-image>食品安全：透明化监管、公开评论&投诉</td></tr>
                        </table>
                    </div>
                    <table class="content_table" v-else>
                        <tr><td><el-image style="height:10px;width:10px;padding-right:10px"  :src="hove.iconImage"></el-image>全网超低价格：深耕</td><td><el-image style="height:10px;width:10px;padding-right:10px"  :src="hove.iconImage"></el-image>高稳定性：月末高峰超强稳定到账</td></tr>
                        <tr><td><el-image style="height:10px;width:10px;padding-right:10px"  :src="hove.iconImage"></el-image>三网全覆盖：移动、联通、电信</td><td><el-image style="height:10px;width:10px;padding-right:10px"  :src="hove.iconImage"></el-image>数据可视化：随时查看数据、财务对账</td></tr>
                        <tr><td><el-image style="height:10px;width:10px;padding-right:10px"  :src="hove.iconImage"></el-image>精细化运营：聚焦业务核心赋能增长</td><td><el-image style="height:10px;width:10px;padding-right:10px"  :src="hove.iconImage"></el-image>智能分发：低延迟高成功率</td></tr>
                    </table>
                    <div @click.prevent="skipModel('content1')"><el-link class="primary_button" :underline="false" href="#content1">立刻咨询</el-link></div>
                    <!-- <el-button type="primary" round><el-link href="#content1">立刻咨询</el-link></el-button> -->
                </div>
                <div style="position:relative;top:-30px;z-index:99;cursor: pointer;"  @click="$router.push('/product')">
                    <el-image :src="hove.content.img" style="height:350px;width:440px"></el-image>
                </div>
            </div>
            <div >
                <div>
                    <div class="content_top">平台能力地图</div>
                     <div class="content_text">科技赋予增长，我们共创未来</div>
                </div>
                <div class="carcusel_inner">
                    <div class="carcusel">
                        <el-carousel :interval="6000" type="card" height="340px"  arrow="always">
                            <el-carousel-item v-for="(item,index) in hove.capability" :key="index">
                                <div style="padding:50px 40px 50px 50px">
                                    <div class="capability_title">{{item.title}}</div>
                                    <div class="capability_content" v-html="item.content">
                                        <!-- {{item.content}} -->
                                    </div>
                                    <el-image class="capability_img"  :src="item.img"></el-image>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
export default {
    props: ['message',"address"],
    data(){
        return{
        //   hove:{

        //       bannar:[
        //       {img:require('./../assets/bannar.png'),},
        //       {img:require('./../assets/bannar1.png'),}
        //      ],
        //       referrer:[
        //          {img:require('./../assets/referrer.png'), text:"全网覆盖",font:"移动、联通、电信",color:"#8398E2",left:"37px;",top:"60px;"  },
        //          {img:require('./../assets/referrer2.png'),text:"种类齐全",font:"话费、流量、带票、新入网",color:"#FE8924",left:"30px;",top:"60px;"   },
        //          {img:require('./../assets/referrer3.png'),text:"精细化运营",font:"极低投入、流量变现",color:"#5C3BDA",left:"30px;",top:"60px;" },
        //      ],
        //      content:{img:require('./../assets/comper1.png'),top:"营销运营平台",text:"专注高效、协同合作、成就客户、激情奋斗、开放进取、分享共赢",},
        //      iconImage:require('./../assets/＊.png'),
        //      capability:[
        //          {title:"自研平台",content:`大厂出身 <span style='color:#F79C38'>15</span> 年技术经验带队 、组建研发团队、自研核心技术、算法、理念让系统算法更加精准，确保平台超高稳定性`,img:require("./../assets/capability1.png")},
        //          {title:"数据监控",content:"在每个<span style='color:#F79C38'>场景</span>中感知业务变化，监控功能使用状态、核心流程转化，性能体验问题，全面了解系统数据现状，智能预测关键指标变化趋势，预警提示及时采取行动。",img:require("./../assets/capability1.png")},
        //          {title:"智能分析",content:"数据智能<span style='color:#F79C38'>BI</span>、强大的技术支撑多维度分析与报表智能钻取、酷炫<span style='color:#F79C38'>BI</span>可视化通过下钻、上卷、旋转、联动等OLAP多维分析功能，支持众多的图表类型和财务报表",img:require("./../assets/capability1.png")},
        //          {title:"市场开拓",content:"强大的市场团队, 以明确市场战略定位，利用既有的市场资源进行产品市场基础建设，从C端，B端，G端不同渠道进行深度调研，剖析，为产品开发提供前沿支撑。",img:require("./../assets/capability1.png")},
        //          {title:"精细化运营",content:"拥有成熟的运营体系，积累了丰富的平台资源和网络营销经验，从品牌到平台运营推广和维护，从产品、用户、内容全维度层面制定产品研发期、种子期、成长期、成熟期全周期的精细化运营策略。",img:require("./../assets/capability1.png")}
        //      ]
        //   },
          //营销运营平台
          hove:{
            bannar:[
                {img:require('./../assets/bannar1.png'),},
              {img:require('./../assets/bannar.png'),},
             ],
             state:true,
              referrer:[
                 {img:require('./../assets/referrer4.png'), text:"政府端",font:"科技赋能、降本增效",color:"#8398E2",left:"4px;",top:"12px;"  },
                 {img:require('./../assets/referrer2.png'),text:"商户端",font:"信用背书、资金安全",color:"#FE8924",left:"4px;",top:"12px;"   },
                 {img:require('./../assets/referrer5.png'),text:"消费者端",font:"监管透明、食品安全有保障",color:"#5C3BDA",left:"4px;",top:"12px;" },
             ],
             content:{img:require('./../assets/comper.png'),top:"智慧放心码",text:"专注高效、协同合作、成就客户、激情奋斗、开放进取、分享共赢",},
             iconImage:require('./../assets/＊.png'),
             capability:[
                 {title:"自研平台",content:`大厂出身 <span style='color:#F79C38'>15</span> 年技术经验带队 、组建研发团队、自研核心技术、算法、理念让系统算法更加精准，确保平台超高稳定性`,img:require("./../assets/capability1.png")},
                 {title:"数据监控",content:"在每个<span style='color:#F79C38'>场景</span>中感知业务变化，监控功能使用状态、核心流程转化，性能体验问题，全面了解系统数据现状，智能预测关键指标变化趋势，预警提示及时采取行动。",img:require("./../assets/capability1.png")},
                 {title:"智能分析",content:"数据智能<span style='color:#F79C38'>BI</span>、强大的技术支撑多维度分析与报表智能钻取、酷炫<span style='color:#F79C38'>BI</span>可视化通过下钻、上卷、旋转、联动等OLAP多维分析功能，支持众多的图表类型和财务报表",img:require("./../assets/capability1.png")},
                 {title:"市场开拓",content:"强大的市场团队, 以明确市场战略定位，利用既有的市场资源进行产品市场基础建设，从C端，B端，G端不同渠道进行深度调研，剖析，为产品开发提供前沿支撑。",img:require("./../assets/capability1.png")},
                 {title:"精细化运营",content:"拥有成熟的运营体系，积累了丰富的平台资源和网络营销经验，从品牌到平台运营推广和维护，从产品、用户、内容全维度层面制定产品研发期、种子期、成长期、成熟期全周期的精细化运营策略。",img:require("./../assets/capability1.png")}
             ]
          },
          data:{
            bannar:[
                {img:require('./../assets/bannar1.png'),},
              {img:require('./../assets/bannar.png'),},
             ],
              referrer:[
                 {img:require('./../assets/referrer.png'), text:"全网覆盖",font:"移动、联通、电信",color:"#8398E2",left:"4px;",top:"12px;"  },
                 {img:require('./../assets/referrer2.png'),text:"种类齐全",font:"话费、流量、带票、新入网",color:"#FE8924",left:"4px;",top:"12px;"   },
                 {img:require('./../assets/referrer3.png'),text:"精细化运营",font:"极低投入、流量变现",color:"#5C3BDA",left:"4px;",top:"12px;" },
             ],
             content:{img:require('./../assets/comper1.png'),top:"营销运营平台",text:"专注高效、协同合作、成就客户、激情奋斗、开放进取、分享共赢",},
             iconImage:require('./../assets/＊.png'),
             capability:[
                 {title:"自研平台",content:`大厂出身 <span style='color:#F79C38'>15</span> 年技术经验带队 、组建研发团队、自研核心技术、算法、理念让系统算法更加精准，确保平台超高稳定性`,img:require("./../assets/capability1.png")},
                 {title:"数据监控",content:"在每个<span style='color:#F79C38'>场景</span>中感知业务变化，监控功能使用状态、核心流程转化，性能体验问题，全面了解系统数据现状，智能预测关键指标变化趋势，预警提示及时采取行动。",img:require("./../assets/capability1.png")},
                 {title:"智能分析",content:"数据智能<span style='color:#F79C38'>BI</span>、强大的技术支撑多维度分析与报表智能钻取、酷炫<span style='color:#F79C38'>BI</span>可视化通过下钻、上卷、旋转、联动等OLAP多维分析功能，支持众多的图表类型和财务报表",img:require("./../assets/capability1.png")},
                 {title:"市场开拓",content:"强大的市场团队, 以明确市场战略定位，利用既有的市场资源进行产品市场基础建设，从C端，B端，G端不同渠道进行深度调研，剖析，为产品开发提供前沿支撑。",img:require("./../assets/capability1.png")},
                 {title:"精细化运营",content:"拥有成熟的运营体系，积累了丰富的平台资源和网络营销经验，从品牌到平台运营推广和维护，从产品、用户、内容全维度层面制定产品研发期、种子期、成长期、成熟期全周期的精细化运营策略。",img:require("./../assets/capability1.png")}
             ]
          },
          //放心🐎
          data1:{
             bannar:[
                 {img:require('./../assets/bannar1.png'),},
              {img:require('./../assets/bannar.png'),},
             ],
             state:true,
              referrer:[
                 {img:require('./../assets/referrer4.png'), text:"政府端",font:"科技赋能、降本增效",color:"#8398E2",left:"4px;",top:"12px;"  },
                 {img:require('./../assets/referrer2.png'),text:"商户端",font:"信用背书、资金安全",color:"#FE8924",left:"4px;",top:"12px;"   },
                 {img:require('./../assets/referrer5.png'),text:"消费者端",font:"监管透明、食品安全有保障",color:"#5C3BDA",left:"4px;",top:"12px;" },
             ],
             content:{img:require('./../assets/comper.png'),top:"智慧放心码",text:"专注高效、协同合作、成就客户、激情奋斗、开放进取、分享共赢",},
             iconImage:require('./../assets/＊.png'),
             capability:[
                 {title:"自研平台",content:`大厂出身 <span style='color:#F79C38'>15</span> 年技术经验带队 、组建研发团队、自研核心技术、算法、理念让系统算法更加精准，确保平台超高稳定性`,img:require("./../assets/capability1.png")},
                 {title:"数据监控",content:"在每个<span style='color:#F79C38'>场景</span>中感知业务变化，监控功能使用状态、核心流程转化，性能体验问题，全面了解系统数据现状，智能预测关键指标变化趋势，预警提示及时采取行动。",img:require("./../assets/capability1.png")},
                 {title:"智能分析",content:"数据智能<span style='color:#F79C38'>BI</span>、强大的技术支撑多维度分析与报表智能钻取、酷炫<span style='color:#F79C38'>BI</span>可视化通过下钻、上卷、旋转、联动等OLAP多维分析功能，支持众多的图表类型和财务报表",img:require("./../assets/capability1.png")},
                 {title:"市场开拓",content:"强大的市场团队, 以明确市场战略定位，利用既有的市场资源进行产品市场基础建设，从C端，B端，G端不同渠道进行深度调研，剖析，为产品开发提供前沿支撑。",img:require("./../assets/capability1.png")},
                 {title:"精细化运营",content:"拥有成熟的运营体系，积累了丰富的平台资源和网络营销经验，从品牌到平台运营推广和维护，从产品、用户、内容全维度层面制定产品研发期、种子期、成长期、成熟期全周期的精细化运营策略。",img:require("./../assets/capability1.png")}
             ]
          },
           // 图片父容器高度
      bannerHeight: 1000,
      // 浏览器宽度
      screenWidth: 0
        }
    }, 
    mounted () {
        // 首次加载时,需要调用一次
        this.screenWidth = window.innerWidth
        this.setSize()
        // 窗口大小发生改变时,调用一次
        window.onresize = () => {
        this.screenWidth = window.innerWidth
        this.setSize()
        }
    },
      methods: {
        setSize: function () {
            // 通过浏览器宽度(图片宽度)计算高度  
            this.bannerHeight = 589.9 / 1550 * this.screenWidth
        },
        elCarousel(item){
           if(item == 0){
               this.hove = this.data1
           }
           if(item == 1){
               this.hove = this.data
           }
        },
        onClick(i){
            console.log(i,this.address)
            this.$router.push("/imgViews?address="+ this.address.code + "&i=" +i.id)
        },
        skipModel(anchor){
            document.querySelector('#'+ anchor).scrollIntoView({behavior: "smooth"});
        }
    }
}
</script>


<style scoped>
  @import "./../style/index.scss";

</style>


// WEBPACK FOOTER //
// src/components/index.vue